module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box new-product-box",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [(_vm.data.showTitle === 'SHOW') ? _c('div', {
    staticClass: "new-title"
  }, [_vm._v("NEW ARRIVAL")]) : _vm._e(), _vm._v(" "), (_vm.products) ? _c('div', {
    staticClass: "products-wrap"
  }, [_c('div', {
    staticClass: "items-wrap",
    attrs: {
      "id": 'newBox' + _vm.modIndex
    }
  }, [_c('div', {
    staticClass: "items"
  }, [_vm._l((_vm.products), function(p, index) {
    return _c('div', {
      key: p.id,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.productAction(p, index)
        }
      }
    }, [_c('div', {
      staticClass: "single-img-box"
    }, [_c('beast-image', {
      staticClass: "single-img",
      attrs: {
        "lazy": true,
        "defaultImage": _vm.defaultImage,
        "src": p.featureImage
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "brand"
    }, [_vm._v(_vm._s(p.brand ? p.brand.name : ''))])])
  }), _vm._v(" "), (_vm.showMoreFlag) ? _c('div', {
    staticClass: "show-more-box"
  }, [(_vm.showMoreFlag) ? _c('div', {
    staticClass: "show-more",
    on: {
      "click": _vm.showMoreAction
    }
  }, [_vm._v("查看更多"), _c('span', {
    staticClass: "arrow"
  })]) : _vm._e()]) : _vm._e()], 2)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cd259a1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/new.vue
// module id = 641
// module chunks = 1 13